.verification {
  padding: 1.5rem;
  border-radius: 16px;
  background: var(--color-text-on-primary);
  color: var(--color-text);
  box-shadow: 0 1px 3px rgba(15, 43, 60, 0.08);
}

.eyebrow {
  margin: 0 0 0.25rem;
  color: var(--color-link);
  font-size: var(--font-size-small);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.heading {
  margin: 0 0 1.25rem;
  font-family: var(--font-family-heading);
  font-size: 1.75rem;
  font-weight: 400;
  color: var(--color-primary);
}

.facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin: 0 0 1rem;
}

.facts dt {
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
}

.facts dd {
  margin: 0;
  font-family: var(--font-family-heading);
  font-size: 2rem;
  line-height: 1.1;
  color: var(--color-primary);
  overflow-wrap: anywhere;
}

.series {
  margin: 0 0 1.5rem;
}

/* Vertical on small screens: the line runs down the left side. */
.timeline {
  position: relative;
  list-style: none;
  margin: 0;
  padding: 0 0 0 2rem;
  display: grid;
  gap: 1.25rem;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 0.6rem;
  top: 0.5rem;
  bottom: 0.5rem;
  width: 3px;
  border-radius: 2px;
  background: linear-gradient(180deg, var(--color-cta), var(--color-accent));
}

.timeline li {
  position: relative;
  display: flex;
  flex-direction: column;
}

.marker {
  position: absolute;
  left: -1.75rem;
  top: 0.3rem;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background: var(--color-cta);
  border: 3px solid var(--color-text-on-primary);
}

.last .marker {
  left: -2rem;
  top: 0;
  width: 22px;
  height: 22px;
  border: 0;
  background: none;
  fill: var(--color-accent);
}

.surveyName {
  font-weight: 600;
}

.period {
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
}

/* Horizontal on wide screens: the line runs along the top of the surveys. */
@media (min-width: 1000px) {
  .timeline {
    grid-auto-flow: column;
    grid-auto-columns: minmax(0, 1fr);
    padding: 2rem 0 0;
  }

  .timeline::before {
    left: 0.5rem;
    right: 0.5rem;
    top: 0.6rem;
    bottom: auto;
    width: auto;
    height: 3px;
    background: linear-gradient(90deg, var(--color-cta), var(--color-accent));
  }

  .marker {
    left: 0;
    top: -1.75rem;
  }

  .last .marker {
    left: -0.2rem;
    top: -2.05rem;
  }
}

.domains {
  margin-top: 1.5rem;
}

.domainsHeading {
  margin: 0 0 0.5rem;
  font-size: var(--font-size-small);
  font-weight: 600;
  color: var(--color-text-muted);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.chips li {
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  background: var(--color-background);
  font-size: var(--font-size-small);
  overflow-wrap: anywhere;
}
